/**
 * padLeft: 在数字左边补零
 * ridLeft: 去掉数字左边零
 * ridCommaForNumber： 去掉数字的逗号
 * padArray: 扩展数组长度
 * validateNumber: 判断是否数字
 * validateEmail: 验证邮箱是否合法
 * validatePhoneNumber:验证手机号码是否合法
 * validateIdentityCard:验证IDcard号码
 * validateUrl: 验证url是否合法
 * countStringLength: 计算字符串长度，兼容中文
 * validateStringLength: 检查字符串长度
 * getFileSize: 获取文件大小
 * getSizeByFileObj:根据文件对象获取文件大小
 * getFileSuffix: 获取文件后缀
 * getFileSuffixByFileObj:根据文件对象获取文件后缀
 * validateImageFile: 检验图片规格
 * convertSecondToColonSeparatedString: 把秒数转换成冒号分隔的字符串
 * validateDate: 检查日期
 * formatDate: 格式化日期
 * parserDate：本地时间转中国标准时间
 * LocalTimeToUTCTime: 本地时间转UTC时间
 * UTCTimeToLocalTime: UTC时间转本地时间
 * getQueryStringParams: 获取url地址的query信息
 * getWeekStartDate: 获取本周开始日期
 * getMonthStartDate: 获得本月的开始日期
 * getLastMonthStartDate: 获得上月的开始日期
 * getLastMonthEndDate: 获得上月的结束日期
 * formatnumber: 保留小数
 * setCookie: 写入cookies
 * getCookie: 读取cookies
 * delCookie: 删除cookies
 * rewardsTransfer: 奖励字符串转换图片
 * getIconPath: 获取icon图片
 */



var Utils = module.exports = {
    /**
     * 在数字左边补零
     * @param number 数字
     * @param length 补零后的字符串总长度
     * @returns {string} 补零后的字符串
     */
    padLeft: function(number, length) {
        var string = number.toString();

        while (string.length < length) {
            string = '0' + string;
        }

        return string;
    },
    /**
     * 去掉数字左边零
     * @param number 数字
     * @returns {string} 补零后的字符串
     */
    ridLeft: function(number) {
        var string = number.toString();

        string = string.replace(/\b(0+)/gi, ''); // 去掉字符串前面的0

        return string;
    },
    /**
     * 去掉数字的逗号
     * @param number 数字
     * @returns {string} 去掉逗号字符串
     */
    ridCommaForNumber: function(number) {
        var string = number.toString();

        string = string.replace(',', ''); // 去掉字符串里的','

        return string;
    },
    /**
     * 扩展数组长度
     * @param array 数组
     * @param length 变更后长度
     * @param content 扩展加插的元素，默认为''
     * @returns {Array} 扩展后的数组
     */
    padArray: function(array, length, content) {
        content === undefined ? '' : content;
        array.length = length;
        for (var i = 0; i < array.length; i++) {
            array[i] === undefined ? array[i] = content : '';
        }

        return array;
    },
    /**
     * 判断是否数字
     *
     * @param str
     * @returns
     */
    validateNumber: function(str) {
        return /^[0-9]$/.test(str);
    },
    /**
     * 验证邮箱是否合法
     * @param email 邮箱
     * @returns {boolean} 是否合法
     */
    validateEmail: function(email) {
        return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            .test(email);
    },

    /**
     * 验证手机号码格式
     * @param phone 手机号码
     * @returns {boolean} 是否合法
     */
    validatePhoneNumber: function(phone) {
        return /^[0-9]{6,12}$/.test(phone);
    },

    /**
     * 验证IDcard格式
     * @param identityCard idcard号码
     * @returns {boolean} 是否合法
     */
    validateIdentityCard: function(identityCard) {
        return /^[0-9]{13}$/.test(identityCard);
    },

    /**
     * 验证url是否合法
     * @param url url地址
     * @returns {boolean} 是否合法
     */
    validateUrl: function(url) {
        return /[a-z]+:\/\/[a-z0-9_\-\/.%]+/i.test(url);

    },

    /**
     * 计算字符串长度，兼容中文
     * @param string 字符串
     * @returns {*} 长度
     */
    countStringLength: function(string) {
        var chineseCharacters = string.match(/[^ -~]/g);

        return string.length + (chineseCharacters ? chineseCharacters.length : 0);
    },

    /**
     * 检查字符串长度
     * @param string 字符串，min 最小值，max 最大值
     * @returns {boolean} 是否在[min, max]之间
     */
    validateStringLength: function(string, min, max) {
        var length = Utils.countStringLength(string);
        return (length < min || length > max) ? false : true;
    },

    /**
     * 获取文件大小
     * @param id 上传元素id
     * @returns {*} 文件大小, 单位为MB
     */
    getFileSize: function(id) {
        var imgFile = document.getElementById(id);
        if (imgFile.files[0]) {
            var size = imgFile.files[0].size / 1024 / 1024; // 初始值单位为 byte

            return size;
        } else {
            return null;
        }

    },
    /**
     * 获取文件大小
     * @param imgFile 文件对象
     * @returns
     */
    getSizeByFileObj: function(imgFile) {
        if (imgFile.files[0]) {
            var size = imgFile.files[0].size / 1024 / 1024; // 初始值单位为 byte

            return size;
        } else {
            return null;
        }
    },

    /**
     * 获取文件后缀
     * @param id 上传元素id
     * @returns {String} 后缀名称
     */
    getFileSuffix: function(id) {
        var imgFile = document.getElementById(id);
        if (imgFile.files[0]) {
            var imgFileName = imgFile.files[0].name;
            var suffix = imgFileName.substring(imgFileName.lastIndexOf('.') + 1).toLowerCase();

            return suffix;
        } else {
            return null;
        }
    },
    /**
     * 通过文件对象获取文件后缀
     * @param imgFile 文件对象
     * @returns {String} 后缀名称
     */
    getFileSuffixByFileObj: function(imgFile) {
        if (imgFile.files[0]) {
            var imgFileName = imgFile.files[0].name;
            var suffix = imgFileName.substring(imgFileName.lastIndexOf('.') + 1).toLowerCase();

            return suffix;
        } else {
            return null;
        }
    },


    /**
     * 检验图片规格
     * @param id 上传元素id，max 图片大小
     * @returns {boolean} 是否符合规则
     */
    validateImageFile: function(id, max) {
        var suffix = Utils.getFileSuffix(id);
        var size = Utils.getFileSize(id);

        if (suffix == null || size == null) {
            return false;
        }

        var imgSuffixs = ['jpg', 'png', 'jpeg'];
        var idx = imgSuffixs.indexOf(suffix);

        return (idx > -1 && size <= max);
    },
    /**
     * 通过文件对象检验图片规格
     * @param imgFile 文件对象，max 图片大小
     * @returns {boolean} 是否符合规则
     */
    validateImageByFileObj: function(imgFile, max) {
        var suffix = Utils.getFileSuffixByFileObj(imgFile);
        var size = Utils.getSizeByFileObj(imgFile);

        if (suffix == null || size == null) {
            return false;
        }

        var imgSuffixs = ['jpg', 'png', 'jpeg'];
        var idx = imgSuffixs.indexOf(suffix);

        return (idx > -1 && size <= max);
    },
    /**
     * 把秒数转换成冒号分隔的字符串
     * @param second 秒数
     * @param hourShouldShow {boolean} 是否显示小时，默认不显示
     * @returns {string} 冒号分隔的字符串
     */
    convertSecondToColonSeparatedString: function(second, hourShouldShow) {
        hourShouldShow = typeof(hourShouldShow) === 'undefined' ? false : hourShouldShow;

        var minuteString = Utils.padLeft(Math.floor(second % 3600 / 60).toString(), 2);
        var secondString = Utils.padLeft(Math.floor(second % 60).toString(), 2);
        if (hourShouldShow) {
            var hourString = Utils.padLeft(Math.floor(second / 3600).toString(), 2);
            return hourString + ':' + minuteString + ':' + secondString;
        }

        return minuteString + ':' + secondString;
    },

    /**
     * 检查日期
     * @param dateString 日期字符串，格式为(YYYY-MM-DD)
     * @returns {boolean} 是否符合规则 （现时判断是否为今日之后的时间）
     */
    validateDate: function(dateString) {
        var date = new Date(dateString.replace(/-/g, '/')),
            now = new Date(),
            gap = now.getTime() - date.getTime(),
            string = Utils.convertSecondToColonSeparatedString(Math.floor(gap / 1000), true),
            split = string.split(':'),
            hour = split[0] >> 0,
            min = split[1] >> 0,
            sec = split[2] >> 0;

        var flag = false;
        if (gap < 0) {
            flag = true;
        } else if (hour < 24) {
            flag = true;
        }

        return flag;
    },


    /**
     * 格式化日期
     * @param createdAt 数据库储存格式 例(2016-01-01 12:01:01)
     * @param isFullFormat 是否显示完整时间，默认显示。完整为(2016-01-01 12:01:01)，不完整(2016-01-01)
     * @returns {string} 格式化后的时间字符串
     */
    formatDate: function(createdAt, isFullFormat) {
        isFullFormat = isFullFormat === undefined ? true : isFullFormat;
        var date = new Date(createdAt);
        var mon = date.getMonth() + 1;
        var day = date.getDate();
        var hour = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        var timeFormatStr = Utils.padLeft(hour, 2) + ":" + Utils.padLeft(minutes, 2) + ":" + Utils.padLeft(
            seconds, 2);
        var dateFormatStr = date.getFullYear() + "-" + Utils.padLeft(mon, 2) + "-" + Utils.padLeft(day, 2) +
            " " + (isFullFormat ? timeFormatStr : '');

        return dateFormatStr;
    },
    /**
     * 本地时间转中国标准时间
     * @param localTime 本地时间,格式为（YYYY-MM-DD hh:mm:ss / YYYY-MM-DD）
     * @returns {string} 格式化后的时间字符串
     */
    parserDate: function(localTime) {
        var t = Date.parse(localTime);
        if (!isNaN(t)) {
            return new Date(Date.parse(localTime.replace(/-/g, "/")));
        } else {
            return new Date();
        }
    },

    /**
     * 本地时间转UTC时间
     * @param localTime 本地时间,格式为（YYYY-MM-DD hh:mm:ss / YYYY-MM-DD）
     * @param localTimezone. e.g 北京为8，巴基斯坦为5，美国东岸为-5. 默认值为null，取客户端时区
     * @returns {string} 格式化后的时间字符串
     */
    LocalTimeToUTCTime: function(localTime, localTimezone) {
        localTimezone = localTimezone === undefined ? null : localTimezone;

        //判断是否日期格式
        var temp = new Date(localTime);
        if (temp == 'Invalid Date') {
            return new Error('Invalid Date');
        }

        var date = temp; //设定参考时间，以本地为准
        var timeDesignated;
        if (localTime.toString().indexOf(':') > 0) { // 检查时候包含时分秒
            if (localTimezone === null) {
                timeDesignated = date;
            } else {
                timeDesignated = new Date(date.getTime() - localTimezone * 3600000 - date.getTimezoneOffset() *
                    60000).toUTCString();
                timeDesignated = new Date(timeDesignated);
            }

            var year = timeDesignated.getUTCFullYear();
            var month = timeDesignated.getUTCMonth() + 1;
            var day = timeDesignated.getUTCDate();
            var hour = timeDesignated.getUTCHours();
            var min = timeDesignated.getUTCMinutes();
            var sec = timeDesignated.getUTCSeconds();

            var timeFormatStr = Utils.padLeft(hour, 2) + ":" + Utils.padLeft(min, 2) + ":" + Utils.padLeft(sec,
                2);
            var dateFormatStr = year + "-" + Utils.padLeft(month, 2) + "-" + Utils.padLeft(day, 2) + " " +
                timeFormatStr;

            return dateFormatStr;
        } else {
            //只有年月日就返回传入日期
            return localTime;
        }
    },

    /**
     * UTC时间转本地时间
     * @param UTCTime UTC时间,格式为（YYYY-MM-DD hh:mm:ss / YYYY-MM-DD）
     * @param localTimezone. e.g 北京为8，巴基斯坦为5，美国东岸为-5. 默认值为null，取客户端时区
     * @returns {string} 格式化后的时间字符串
     */
    UTCTimeToLocalTime: function(UTCTime, localTimezone) {
        localTimezone = localTimezone === undefined ? null : localTimezone;

        //判断是否日期格式
        var temp = new Date(UTCTime);
        if (temp == 'Invalid Date') {
            return new Error('Invalid Date');
        }

        var re = new RegExp('[a-zA-Z]');
        var date;
        if (re) {
            date = new Date(UTCTime + '+0000'); //设定参考时间，以本地为准
        } else {
            date = new Date(UTCTime + 'Z'); //设定参考时间，以本地为准
        }

        var timeDesignated;
        if (UTCTime.indexOf(':') > 0) { // 检查时候包含时分秒
            if (localTimezone === null) {
                timeDesignated = date;
            } else {
                // 取得 UTC time
                var utc = date.getTime() + (date.getTimezoneOffset() * 60000);

                // 目标时区的时间
                timeDesignated = new Date(utc + (3600000 * localTimezone));
            }
            return Utils.formatDate(timeDesignated);
        } else {
            //只有年月日就返回传入日期
            return UTCTime;
        }
    },

    /**
     * 获取本周开始日期
     */
    getWeekStartDate() {
        var now = new Date();
        var weekStartDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay() + 1); //星期一为第一天
        return Utils.formatDate(weekStartDate);
    },

    /**
     * 获取本月开始日期
     */
    getMonthStartDate() {
        var now = new Date();
        var monthStartDate = new Date(now.getFullYear(), now.getMonth(), 1);
        return Utils.formatDate(monthStartDate);
    },

    /**
     * 获取上月开始日期
     */
    getLastMonthStartDate() {
        var now = new Date();
        var lastMonthDate = new Date(); //上月日期
        lastMonthDate.setDate(1);
        lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
        var lastMonth = lastMonthDate.getMonth();
        var lastMonthStartDate = new Date(now.getFullYear(), lastMonth, 1);
        return Utils.formatDate(lastMonthStartDate);
    },

    /**
     * 获取上月结束日期
     */
    getLastMonthEndDate() {
        var now = new Date();
        var lastMonthDate = new Date(); //上月日期
        lastMonthDate.setDate(1);
        lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
        var lastMonth = lastMonthDate.getMonth();
        var lastMonthEndDate = new Date(now.getFullYear(), lastMonth, Utils.getMonthDays(lastMonth));
        return Utils.formatDate(lastMonthEndDate);
    },

    /**
     * 获取某月天数
     */
    getMonthDays(myMonth) {
        var now = new Date();
        var monthStartDate = new Date(now.getFullYear(), myMonth, 1);
        var monthEndDate = new Date(now.getFullYear(), myMonth + 1, 1);
        var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
        return days;
    },

    /**
     * 格式化数字保留几位小数
     */
    formatnumber: function(value, num) {
        var a, b, c, i;
        a = value.toString();
        b = a.indexOf(".");
        c = a.length;
        if (num == 0) {
            if (b != -1) {
                a = a.substring(0, b);
            }
        } else { //如果没有小数点
            if (b == -1) {
                a = a + ".";
                for (i = 1; i <= num; i++) {
                    a = a + "0";
                }
            } else { //有小数点，超出位数自动截取，否则补0
                a = a.substring(0, b + num + 1);
                for (i = c; i <= b + num; i++) {
                    a = a + "0";
                }
            }
        }
        return a;
    },

    /**
     * 当前日期添加时间
     */
    getNewData(days) {
        var day = new Date()
        var dateTemp = day.getFullYear() + "-" + (day.getMonth() + 1) + "-" + day.getDate();

        dateTemp = dateTemp.split("-");
        var nDate = new Date(dateTemp[1] + '-' + dateTemp[2] + '-' + dateTemp[0]); //转换为MM-DD-YYYY格式
        var millSeconds = Math.abs(nDate) + (days * 24 * 60 * 60 * 1000);
        var rDate = new Date(millSeconds);
        var year = rDate.getFullYear();
        var month = rDate.getMonth() + 1;
        if (month < 10) month = "0" + month;
        var date = rDate.getDate();
        if (date < 10) date = "0" + date;
        return (year + "-" + month + "-" + date);
    },

    /**
     * 获取url地址的query信息
     * @param sParam 获取的key
     * @returns {string} 格式化后的时间字符串
     */

    getQueryStringParams: function(sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] == sParam) {
                return sParameterName[1];
            }
        }
    },

    /**
     * 拼接url
     * @param url 需要拼接的url
     * @param obj 需要拼接的obj
     * @returns {string} url
     */

    splicingParams: function(url, obj) {
        let i = 0;
        for (let item in obj) {
            if (obj.hasOwnProperty(item)) {
                if (!obj[item]) continue;
                if (i === 0) {
                    url += `?${item}=${obj[item]}`;
                } else {
                    url += `&${item}=${obj[item]}`;
                }
                i++;
            }
        }
        return url;
    },

    /**
     * 写入cookies
     * @param name cookies key
     * @param value cookies value
     * @param expiredTime cookies 超时时间
     */
    setCookie: (name, value, expiredTime) => {
        let Days = 30;
        let exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        let _expiredTime = expiredTime ? expiredTime : exp;
        document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + _expiredTime.toUTCString();
    },
    /**
     * 读取cookies
     * @param name cookies key
     * @returns {obj} 读取cookies
     */
    getCookie: name => {
        let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg))
            return decodeURIComponent(arr[2]);
        else
            return null;

    },
    /**
     * 删除cookies
     * @param name cookies key
     */
    delCookie: name => {
        let exp = new Date();
        let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        let cval = (arr = document.cookie.match(reg)) ? encodeURIComponent(arr[2]) : null;
        exp.setTime(exp.getTime() - 1);
        if (cval !== null)
            document.cookie = name + "=" + cval + ";expires=" + exp.toUTCString();
    },

    /**
     * 奖励字符串转换列表
     * @param str 奖励字符串
     * @returns {array} 奖励品列表
     */
    rewardsTransfer: str => {
        var rewardList = str.split(',');
        var list = [];

        rewardList.forEach(reward => {
            list.push({
                id: reward.split('_')[0],
                amount: reward.split('_')[1]
            })
        });

        return list;
    },

    /**
     * 获取icon图片
     * @param id icon编号
     * @param level 等级，type == 2 的时候需要
     * @returns {image} 图片二进制串
     */
    getIconPath: (id, level) => {

        var type = (id).toString().substring(0, 1);
        try {
            if (type == '2') {
                return require('../assets/icons/icon_' + id + '_' + level + '.png');
            } else {
                return require('../assets/icons/icon_' + id + '.png');
            }
        } catch (err) {
            return require('../assets/icons/icon_bg_currency.png');
        }
    },
    /**
     * 表名转换
     * @param str
     * @returns {*[]}
     */
    tableNameTransfer: str =>{
        let splitList = str.split('_');

        let transferResult = '';
        for (let i = 0; i < splitList.length; i++) {
            transferResult += splitList[i].slice(0, 1).toUpperCase() + splitList[i].slice(1);

        }

        return transferResult;
    }
};



// WEBPACK FOOTER //
// ./src/lib/utils.js